const patterns = {
  TimeframeDateFormat: 'YYYY-MM-DD'
}

export default patterns
